module.exports = __webpack_public_path__ + "static/helloworlddisc-2399f3f930a213fdde33464d52d034a4.jpeg";